import { RootStore } from "../stores";

let currentUser = (rootStore: RootStore) => {
    return rootStore?.userStore?.user
}

export default currentUser;